<template>
  <div style="width:100%;position:relative;" class="zj-flex-column">
    <mainPage ref="mainPage" class="zj-flex-column" v-show="mainPageName =='mainPage'"></mainPage>
    <!-- <mainAuxPage ref="mainAuxPage" class="zj-flex-column" v-show="mainPageName =='mainAuxPage'"></mainAuxPage> -->
    <!-- <div class="main-page-tab" data-step="5" data-intro="主页切换">
              <div class="main-tab-item" @click="mainPageName = 'mainAuxPage'" :class="{'is-active': mainPageName == 'mainAuxPage'}">
              </div>
              <div class="main-tab-item" @click="mainPageName = 'cockpit'"
                :class="{'is-active': mainPageName == 'cockpit'}">
              </div>
            </div>
            <transition name="bounce" enter-active-class="bounceInLeft" leave-active-class="bouceOutLeft">
              <mainAuxPage ref="mainAuxPage" class="zj-flex-column" v-show="mainPageName =='mainAuxPage'"></mainAuxPage>
            </transition>
            <transition name="bounce" enter-active-class="bounceInRight" leave-active-class="bouceOutRight">
              <cockpit ref="cockpit" class="zj-flex-column" v-show="mainPageName =='cockpit'"></cockpit>
            </transition>
            <span class="switch-arrow left-arrow" @click="mainPageName = 'mainAuxPage'"></span>
            <span class="switch-arrow right-arrow" @click="mainPageName = 'cockpit'"></span> -->
  </div>
</template>

<script>
import mainAuxPage from "./mainAuxPage";
import mainPage from "./mainPage";
export default {
  components: {
    mainAuxPage,
    mainPage
  },
  data() {
    return {
      mainPageName: "mainPage",
    }
  },
  methods: {}
}
</script>

<style scoped>
.main-page-tab {
  text-align: center;
  height: 30px;
}
.main-tab-item {
  width: 30px;
  height: 5px;
  border-radius: 34px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
  cursor: pointer;
  display: inline-block;
  margin: 10px;
  background-color: white;
  box-sizing: border-box;
  position: relative;
}
/* 通过伪元素扩大可点击范围 */
.main-tab-item::after {
  content: "";
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
}
.main-tab-item.is-active {
  background-color: #409eff;
}
.switch-arrow {
  position: absolute;
  width: 45px;
  height: 75px;
  top: 50%;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0;
  border-radius: 3px;
  cursor: pointer;
}
.switch-arrow:hover {
  opacity: 1;
}
.left-arrow {
  left: 0;
  background-image: url("/assets/img/left-arrow.png");
}
.right-arrow {
  right: 0;
  background-image: url("/assets/img/right-arrow.png");
}
</style>
